import { Illus, PrimaryButton } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useDependencies } from '../../../../state'
import { WriskTrans } from '../../../organisms/trans'
import { FullPage } from '../../../templates'

const tKey = TKey('pages.payment-result-error')

export const PaymentFailure: FunctionComponent = () => {
  const { chatClient } = useDependencies()

  const { t } = useWriskTranslation()

  return (
    <FullPage
      pageId='payment-page'
      header={t(tKey('header'))}
      subheader={<WriskTrans t={t} i18nKey={tKey('subheader')} />}
      upperHeader={<Illus alt='Failure' illus='bindError' />}
    >
      <PrimaryButton layout='fixed' type='submit' onClick={chatClient.show}>
        {t(tKey('actions.continue'))}
      </PrimaryButton>
    </FullPage>
  )
}
